export default [
	{
		slug: 'yam-box',
		cssClass: 'yambox',
		name: 'Yam-Box',
		previewText: 'Сервис по доставке еды',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/yam-box/preview_front.png',
		tags: [
			'Веб-сайты',
			'Интернет-магазины',
			'Приложения',
			'SMM',
			'Дизайн',
			'Баннеры',
			'Брендинг',
			'Маркетинг',
		],
		logo: '/img/projects/yam-box/logo.svg',
		content: `
      <p>
        <b>Доставка вкусной еды (пицца, роллы)</b> <br>
        Компания создана с концепцией франшизы для дальнейшего развития. <a href="https://yam-box.ru" target="_blank">Yam-box.ru</a> 2018 – наст. время.
      </p>
      <ul>
        <li>Разработали новый сайт – приложение по технологии <b>Google PWA</b></li>
        <li>Конверсия в заказ <b>выросла на 30%</b> и продолжает расти</li>
        <li>Новый сайт и приложения открываются за 1,5-3 секунды — это <b>в 4 раза быстрее</b> старых</li>
      </ul>
    `,
		domen: 'Yam-box.ru',
		site: 'https://yam-box.ru',
		appstore: 'https://apps.apple.com/us/app/yambox/id1491755448?l=ru&ls=1',
		googleplay:
			'https://play.google.com/store/apps/details?id=ru.forzik.yambox',
		desktopImg: '/img/projects/yam-box/desktop-1.png',
		iphoneImg: '/img/projects/yam-box/iphone-2.png',
		androidImg: '/img/projects/yam-box/android-1.png',
		aboutList: [
			{
				icon: '/img/projects/good-idea.svg',
				title: 'Идея продукта',
				text: 'В первую очередь нас заинтересовал основатель компании и создатель бренда Вадим. Стали работать вместе с ним, чтобы реализовать идею лучшего сервиса доставки <u>вкусной</u> еды.',
			},
			{
				icon: '/img/projects/complex-approach.svg',
				title: 'Комплексный подход',
				text: 'Стартовали с комплексного аудита ситуации и договорились работать сразу в нескольких направлениях: сайт, приложения, группа в соцсетях, реклама в Яндекс и Google, СЕО, дизайн листовок, баннеров во ВКонтакте и постов, видеореклама для ТВ и YouTube',
			},
			{
				icon: '/img/projects/marketing.svg',
				title: 'Маркетинг-стратегия',
				text: `
          Для нас ниша доставки еды была новым направлением маркетинга. Начали с аудита ситуации на рынке и выдвинули несколько гипотез. В первые два месяца запустили тестовую рекламу в Яндекс, Google, ВК и Instagram. Затем подключили СЕО и СМС-рассылку.
          <br><br>
          Тесты показали, что слабое место сервиса — это неудобный сайт и приложения. Договорились создать новые в течение 5 месяцев.
        `,
			},
			{
				icon: '/img/projects/seo.svg',
				title: 'Результаты (январь 2022)',
				text: `
          <b>Группа ВКонтакте:</b><br>
          1. Увеличили количество продаж через ВК за полгода в 5 раз.<br>
          2. Сократили стоимость привлечения клиента до 80-218 руб.<br>
          3. Внедрили рассылку с оборотом в месяц более 100 000 руб.<br>
          4. Увеличили количество активных подписчиков с 15 000 до 25 000.<br>
          5. Первые в городе внедрили корзину в ВК и начали получать заказы через неё.<br>
          <br>
          <b>Сайт и приложения:</b><br>
          1. Разработали современный SPA-сайт и два приложения с простым и функциональным дизайном на основе маркетингового анализа.<br>
          2. Настроили полную интеграцию сайта и приложений с erp-системой Aiko.<br>
          3. В 3 раза увеличили количество продаж из приложения и сайта. Показатели продолжают расти.<br>
          4. Новый сайт и приложения открываются за 1,5-3 секунды — это в 4 раза быстрее старых.
        `,
			},
		],
	},
	{
		projectLink: 'https://new.pandakemerovo.ru/',
		cssClass: 'panda',
		name: 'Панда',
		previewText: 'Сервис по доставке еды',
		// previewDescription: '',
		// previewBgImg_back: '/img/projects/panda/preview_back.png',
		previewBgImg_front: '/img/projects/panda/preview_front.png',
		tags: [
			'Приложения',
			'Интернет-магазины',
			'Брендинг',
			'Дизайн',
			'Маркетинг',
		],
	},
	{
		projectLink:
			'https://play.google.com/store/apps/details?id=info.markergroup.android&hl=ru',
		cssClass: 'marker',
		name: 'Маркер',
		previewText: 'Сервис аналитики и мониторинга',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/marker/preview_back.png',
		previewBgImg_front: '/img/projects/marker/preview_front.png',
		tags: ['Приложения', 'Инновационный продукт', 'Дизайн'],
	},
	{
		projectLink: 'https://www.ros-color.ru/',
		cssClass: 'roscolor',
		name: 'РосЦвет',
		previewText: 'Текстильная фабрика №1 в России ',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/roscolor/preview_back.jpg',
		previewBgImg_front: '/img/projects/roscolor/preview_front.png',
		tags: [
			'Веб-сайты',
			'Маркетинг',
			'SEO',
			'Дизайн',
			'Баннеры',
			'Интернет-магазины',
		],
	},
	{
		projectLink: 'https://vfinterior.ru/',
		cssClass: 'vfinterior',
		name: 'VFinterior',
		previewText: 'Дизайн интерьера',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/vfinterior/preview_front.png',
		tags: [
			'Веб-сайты',
			'Лендинги',
			'Разработка на Tilda',
			'Логотип',
			'Дизайн',
			'Маркетинг',
		],
	},
	{
		projectLink: 'https://apps.apple.com/ru/app/id1523496529',
		cssClass: 'mkm-app',
		name: 'Москабельмет',
		previewText: 'Завод по производству кабелей',
		// previewDescription: '',
		previewBgImg_back: ' ',
		previewBgImg_front: '/img/projects/mkm-app/logo.svg',
		tags: ['Приложения', 'Инновационный продукт'],
	},
	{
		projectLink: 'https://t.me/MkmRuBot?start',
		cssClass: 'mkm-bot',
		name: 'Москабельмет',
		previewText: 'Чат бот для завода по производству кабелей',
		// previewDescription: '',
		previewBgImg_back: ' ',
		previewBgImg_front: '/img/projects/mkm-bot/telegram-logo.svg',
		tags: ['Чат-бот'],
	},
	{
		projectLink: 'https://luckydo.ru/',
		cssClass: 'luckydo',
		name: 'Lucky Do',
		previewText: 'Сервис по доставке еды',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/luckydo/preview_back.png',
		previewBgImg_front: '/img/projects/luckydo/preview_front.png',
		tags: ['Веб-сайты', 'Интернет-магазины', 'Дизайн', 'Баннеры'],
	},
	{
		projectLink: 'http://biovillage.globalcode.eu/',
		cssClass: 'biovillage-app',
		name: 'Biòvillage',
		previewText: 'Приложение для доставки продуктов',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/biovillage-app/preview_front.png',
		tags: [
			'Приложения',
			'Интернет-магазины',
			'Брендинг',
			'Дизайн',
			'Маркетинг',
			'Логотип',
		],
	},
	{
		projectLink: 'https://caristo.ru/ ',
		cssClass: 'caristo',
		name: 'Caristo',
		previewText: 'Маркетплейс автозапчастей',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/caristo/preview_back.jpg',
		previewBgImg_front: '/img/projects/caristo/preview_front.png',
		tags: [
			'Маркетплейсы',
			'Веб-сайты',
			'Дизайн',
			'Брендинг',
			'Маркетинг',
			'Логотип',
		],
	},
	{
		projectLink: 'https://stokel.ru/',
		cssClass: 'stokel',
		name: 'Стокел',
		previewText: 'Магазин строительных материалов',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/stokel/preview_front.png',
		tags: ['Веб-сайты', 'Интернет-магазины', 'Дизайн', 'Маркетинг'],
	},
	{
		projectLink: 'http://biovillage.globalcode.eu/',
		cssClass: 'biovillage-landing',
		name: 'Biòvillage',
		previewText: 'Лендинг для сервиса по доставке продуктов',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/biovillage-landing/preview_front.svg',
		tags: ['Лендинги', 'Маркетинг', 'Логотип', 'Дизайн', 'Брендинг'],
	},
	{
		projectLink: 'https://ohotta.ru/',
		cssClass: 'ohotta',
		name: 'Ohotta',
		previewText: 'Маркетплейс',
		// previewDescription: '',
		// previewBgImg_back: '',
		previewBgImg_front: '/img/projects/ohotta/preview_front.png',
		tags: [
			'Маркетплейсы',
			'Инновационный продукт',
			'Веб-сайты',
			'SMM',
			'Лендинги',
			'Дизайн',
			'Брендинг',
			'Логотип',
		],
	},
	{
		projectLink: 'https://barel.by/',
		cssClass: 'barel',
		name: 'Barel',
		previewText: 'Магазин обувниц для интерьера',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/barel/preview_back.png',
		previewBgImg_front: '/img/projects/barel/preview_front.png',
		tags: ['Веб-сайты', 'Лендинги', 'Дизайн', 'Разработка на Tilda'],
	},
	{
		projectLink: 'https://space.globalcode.eu/',
		cssClass: 'place-to-space',
		name: 'PlaceToSpace',
		previewText: 'Особенный проект космического масштаба',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/place-to-space/preview_back.jpg',
		previewBgImg_front: '/img/projects/place-to-space/preview_front.png',
		tags: [
			'Веб-сайты',
			'Лендинги',
			'Инновационный продукт',
			'SMM',
			'Дизайн',
			'Брендинг',
			'Мультиязычный сайт',
		],
	},
	{
		projectLink: 'https://its-yug.ru/',
		cssClass: 'its-yug',
		name: 'ИТС-ЮГ',
		previewText: 'Калькулятор и сайт',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/its-yug/preview_back.jpg',
		previewBgImg_front: '/img/projects/its-yug/preview_front.png',
		tags: ['Веб-сайты', 'Лендинги', 'Логотип', 'Дизайн', 'Маркетинг'],
	},
	// {
	// 	projectLink: 'http://mk-electra.ru/',
	// 	cssClass: 'mk-electra',
	// 	name: 'Мк-Электра',
	// 	previewText: 'Лендинг на Tilda',
	// 	// previewDescription: '',
	// 	previewBgImg_back: '/img/projects/mk-electra/preview_back.jpg',
	// 	previewBgImg_front: '/img/projects/mk-electra/preview_front.png',
	// 	tags: [
	// 		'Веб-сайты',
	// 		'Разработка на Tilda',
	// 		'Дизайн',
	// 		'Маркетинг',
	// 		'Лендинги',
	// 	],
	// },
	{
		projectLink: 'https://ovik-m.ru/',
		cssClass: 'ovik',
		name: 'ОВиК',
		previewText: 'Корпоративный сайт',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/ovik/preview_back.jpg',
		// previewBgImg_front: '',
		tags: ['Веб-сайты', 'Лендинги', 'Дизайн', 'Маркетинг'],
	},
	{
		projectLink: 'http://newalaskavolkhov.ru/',
		cssClass: 'new-alaska',
		name: 'Новая Аляска',
		previewText: 'Сайт',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/new-alaska/preview_back.jpg',
		previewBgImg_front: '/img/projects/new-alaska/preview_front.png',
		tags: ['Веб-сайты', 'Дизайн', 'Мультиязычный сайт'],
	},
	{
		projectLink: 'https://planeta12volt.ru/',
		cssClass: 'planeta-12',
		name: 'Планета 12 вольт',
		previewText: 'Автосервис',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/planeta12volt/preview_back.jpg',
		previewBgImg_front: '/img/projects/planeta12volt/preview_front.png',
		tags: ['Веб-сайты', 'Маркетинг', 'Логотип'],
	},
	{
		projectLink: 'http://check-point.pro/',
		cssClass: 'checkpoint',
		name: 'CHECK POINT',
		previewText: 'Автосервис',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/checkpoint/preview_back.jpg',
		// previewBgImg_front: '',
		tags: ['Веб-сайты', 'Лендинги', 'Дизайн', 'Маркетинг'],
	},
	{
		projectLink: 'http://stroysnab.com/',
		cssClass: 'stroysnab',
		name: 'Строй Снаб',
		previewText: 'Магазин стройматериалов',
		// previewDescription: '',
		previewBgImg_back: '/img/projects/stroysnab/preview_back.jpg',
		// previewBgImg_front: '',
		tags: ['Веб-сайты', 'Интернет-магазины', 'Дизайн', 'Маркетинг'],
	},
]
